import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_URL,

  // Добавляет заголовки запросов и IP для определения пользователя (опционально)
  sendDefaultPii: true,

  // Интеграции (подключайте только нужные вам функции)
  integrations: [
    // Для отслеживания производительности (Tracing)
    Sentry.browserTracingIntegration(),
    // Для записи сессий (Session Replay)
    Sentry.replayIntegration(),
  ],

  // Настройки производительности (Tracing)
  tracesSampleRate: 0.2, // % записей транзакций (1.0 = 100%). В продакшене рекомендуется снизить, например, до 0.2

  // Настройки Session Replay
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0, // 100% запись, если произошла ошибка

  // Скрипты автозаполнения, которые встраивают сторонние браузеры (execute_auto_fill), — не наш код
  ignoreErrors: ["xbrowser is not defined", "swbrowser is not defined"],
});